import React from "react";
import { Link } from "react-router-dom";
import OTPScreen2 from "./OtpScreen2";

// Hardcoded, generic internet images (no company branding).
// Modern split-screen auth template.
const HERO_IMAGE =
  "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=80";

const styles = `
.tmpl7-root{min-height:100vh;display:flex;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#0f172a;background:#eef1f8;}
.tmpl7-root *{box-sizing:border-box;}
.tmpl7-hero{position:relative;flex:1.1;overflow:hidden;display:flex;flex-direction:column;justify-content:space-between;padding:48px;color:#fff;background:#0b1220;min-height:100vh;}
.tmpl7-hero-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:.6;}
.tmpl7-hero-overlay{position:absolute;inset:0;background:linear-gradient(135deg,rgba(79,70,229,.88),rgba(139,92,246,.5) 45%,rgba(15,23,42,.9));}
.tmpl7-brand{position:relative;z-index:2;display:flex;align-items:center;gap:12px;font-weight:600;font-size:18px;letter-spacing:.3px;}
.tmpl7-hero-content{position:relative;z-index:2;max-width:480px;}
.tmpl7-hero-content h1{font-size:42px;line-height:1.12;font-weight:700;margin:0 0 18px;letter-spacing:-.6px;}
.tmpl7-hero-content p{font-size:16px;line-height:1.65;color:rgba(255,255,255,.82);margin:0;}
.tmpl7-hero-foot{position:relative;z-index:2;font-size:13px;color:rgba(255,255,255,.6);}
.tmpl7-logo{width:44px;height:44px;border-radius:12px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#6366f1,#8b5cf6);box-shadow:0 8px 24px rgba(99,102,241,.45);}
.tmpl7-panel{flex:1;display:flex;align-items:center;justify-content:center;padding:40px 24px;background:#eef1f8;}
.tmpl7-card{width:100%;max-width:400px;}
.tmpl7-card-brand{display:none;align-items:center;gap:12px;margin-bottom:28px;font-weight:600;font-size:18px;color:#0f172a;}
.tmpl7-card-brand .tmpl7-logo{width:40px;height:40px;}
.tmpl7-title{font-size:28px;font-weight:700;margin:0 0 8px;letter-spacing:-.4px;color:#0f172a;}
.tmpl7-sub{font-size:15px;color:#64748b;margin:0 0 32px;}
.tmpl7-field{margin-bottom:20px;}
.tmpl7-label{display:block;font-size:13px;font-weight:600;color:#334155;margin-bottom:8px;}
.tmpl7-input-wrap{position:relative;}
.tmpl7-input{width:100%;height:48px;border:1px solid #e2e8f0;border-radius:12px;padding:0 44px 0 16px;font-size:15px;color:#0f172a;background:#fff;transition:border-color .15s,box-shadow .15s;outline:none;}
.tmpl7-input::placeholder{color:#94a3b8;}
.tmpl7-input:focus{border-color:#6366f1;box-shadow:0 0 0 4px rgba(99,102,241,.12);}
.tmpl7-eye{position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:#94a3b8;padding:6px;display:flex;align-items:center;}
.tmpl7-eye:hover{color:#6366f1;}
.tmpl7-options{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;min-height:20px;}
.tmpl7-check{display:flex;align-items:center;gap:8px;font-size:14px;color:#475569;cursor:pointer;user-select:none;}
.tmpl7-check input{width:16px;height:16px;accent-color:#6366f1;cursor:pointer;}
.tmpl7-link{font-size:14px;color:#6366f1;font-weight:600;text-decoration:none;}
.tmpl7-link:hover{text-decoration:underline;}
.tmpl7-btn{width:100%;height:50px;border:none;border-radius:12px;background:linear-gradient(135deg,#6366f1,#8b5cf6);color:#fff;font-size:16px;font-weight:600;cursor:pointer;transition:transform .12s,box-shadow .2s,opacity .2s;box-shadow:0 10px 24px rgba(99,102,241,.35);display:flex;align-items:center;justify-content:center;gap:8px;}
.tmpl7-btn:hover{transform:translateY(-1px);box-shadow:0 14px 30px rgba(99,102,241,.45);}
.tmpl7-btn:active{transform:translateY(0);}
.tmpl7-btn:disabled{opacity:.55;cursor:not-allowed;box-shadow:none;transform:none;}
.tmpl7-recaptcha{margin-bottom:18px;display:flex;justify-content:center;}
.tmpl7-otp-wrap{margin-top:8px;}
@media (max-width: 900px){
  .tmpl7-hero{display:none;}
  .tmpl7-card-brand{display:flex;}
}
`;

const LogoMark = () => (
  <span className="tmpl7-logo">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 2l2.6 6.8L21 11l-6.4 2.2L12 20l-2.6-6.8L3 11l6.4-2.2z" fill="#fff" />
    </svg>
  </span>
);

const EyeIcon = ({ off }) =>
  off ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

class Template7 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isChecked: false,
      isShowPassword: false,
      twoFAStatus: null,
    };
  }

  updateTwoFAStatus = (t) => {
    this.setState({ twoFAStatus: t });
  };

  onLogin = () => {
    const { email, password, isChecked } = this.state;
    const { authenticationCallback, itemProperties, sessionId, twoFA } = this.props;
    if (isChecked && email !== "") {
      localStorage.username = email;
      localStorage.password = password;
      localStorage.checkbox = isChecked;
    }
    const payload = {
      email,
      password,
    };

    if (twoFA) {
      this.props.setError(false);
      this.props.login(payload, () => {
        this.updateTwoFAStatus("OTP");
      });
    } else {
      if (itemProperties && itemProperties.authenticateUsingPlugins) {
        payload["authenticateUsingPlugins"] = true;
        payload["sessionId"] = sessionId;
      }
      this.props.setError(false);
      this.props.login(payload, authenticationCallback);
    }
  };

  togglePasswordVisiblity = () => {
    this.setState({ isShowPassword: !this.state.isShowPassword });
  };

  onKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onLogin();
    }
  };

  render() {
    const {
      label,
      hasForgotPassword,
      authTemplateTopFormText,
      itemProperties,
      authenticationCallback,
    } = this.props;

    const rememberMe =
      itemProperties && itemProperties.authConfig && itemProperties.authConfig.rememberMe;
    const otpScreenLabel = itemProperties && itemProperties.otpScreenLabel;
    const isOtp = this.state.twoFAStatus === "OTP";

    return (
      <div className="tmpl7-root">
        <style dangerouslySetInnerHTML={{ __html: styles }} />

        {/* Left hero (generic, hardcoded internet image) */}
        <div className="tmpl7-hero">
          <img className="tmpl7-hero-img" src={HERO_IMAGE} alt="" />
          <div className="tmpl7-hero-overlay" />
          <div className="tmpl7-brand">
            <LogoMark />
            <span>Your Platform</span>
          </div>
          <div className="tmpl7-hero-content">
            <h1>Welcome back.</h1>
            <p>
              Sign in to access your dashboard, manage your workflows and pick up
              right where you left off.
            </p>
          </div>
          <div className="tmpl7-hero-foot">
            © {new Date().getFullYear()} · Secured sign in
          </div>
        </div>

        {/* Right form panel */}
        <div className="tmpl7-panel">
          <div className="tmpl7-card">
            <div className="tmpl7-card-brand">
              <LogoMark />
              <span>Your Platform</span>
            </div>

            {isOtp ? (
              <>
                <h2 className="tmpl7-title">
                  {otpScreenLabel ? otpScreenLabel : "One-Time Password"}
                </h2>
                <p className="tmpl7-sub">
                  Enter the verification code we just sent you.
                </p>
                <div className="tmpl7-otp-wrap">
                  <OTPScreen2
                    authenticationCallback={authenticationCallback}
                    requiredRole={itemProperties && itemProperties.requiredRole}
                    phoneNumber={this.state.email}
                  />
                </div>
              </>
            ) : (
              <>
                <h2 className="tmpl7-title">
                  {authTemplateTopFormText || "Sign in"}
                </h2>
                <p className="tmpl7-sub">
                  Please enter your details to continue.
                </p>

                <div className="tmpl7-field">
                  <label className="tmpl7-label" htmlFor="tmpl7-email">
                    Email
                  </label>
                  <div className="tmpl7-input-wrap">
                    <input
                      id="tmpl7-email"
                      className="tmpl7-input"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      onKeyDown={this.onKeyDown}
                      placeholder="you@example.com"
                      type="text"
                      autoComplete="username"
                    />
                  </div>
                </div>

                <div className="tmpl7-field">
                  <label className="tmpl7-label" htmlFor="tmpl7-password">
                    Password
                  </label>
                  <div className="tmpl7-input-wrap">
                    <input
                      id="tmpl7-password"
                      className="tmpl7-input"
                      value={this.state.password}
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      onKeyDown={this.onKeyDown}
                      placeholder="Enter your password"
                      type={this.state.isShowPassword ? "text" : "password"}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className="tmpl7-eye"
                      onClick={this.togglePasswordVisiblity}
                      aria-label={
                        this.state.isShowPassword
                          ? "Hide password"
                          : "Show password"
                      }
                    >
                      <EyeIcon off={this.state.isShowPassword} />
                    </button>
                  </div>
                </div>

                <div className="tmpl7-options">
                  {rememberMe ? (
                    <label className="tmpl7-check">
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={(e) =>
                          this.setState({ isChecked: e.target.checked })
                        }
                      />
                      Remember me
                    </label>
                  ) : (
                    <span />
                  )}
                  {hasForgotPassword ? (
                    <Link className="tmpl7-link" to="/app/forgotpassword">
                      Forgot password?
                    </Link>
                  ) : (
                    <span />
                  )}
                </div>

                {this.props.reCaptchaComponent ? (
                  <div className="tmpl7-recaptcha">
                    {this.props.reCaptchaComponent}
                  </div>
                ) : null}

                <button
                  type="button"
                  className="tmpl7-btn"
                  disabled={this.props.displayReCaptcha}
                  onClick={this.onLogin}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                  {label && label.show ? label.text : "Sign in"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Template7;
